const EMPLOYEE_DELAY = 3000; // 3 seconds
const EMPLOYEE_EXPIRY = 14 * 86400 * 1000; // 14 days

const EMPLOYER_DELAY = 45000; // 45 seconds
const EMPLOYER_EXPIRY = 14 * 86400 * 1000; // 14 days

const setExpirableItem = (key, value, ttl) => {
    const now = new Date();

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
        value: value,
        expiry: now.getTime() + ttl
    };

    localStorage.setItem(key, JSON.stringify(item));
};

const getExpirableItem = (key) => {
    const itemStr = localStorage.getItem(key);

    // if the item doesn't exist, return null
    if (!itemStr) {
        return null;
    }

    const item = JSON.parse(itemStr);
    const now = new Date();

    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage
        // and return null
        localStorage.removeItem(key);
        return null;
    }
    return item.value;
};

const showEmployerPopup = () => {
    const container = document.getElementById('employer-popup');

    if (!container || getExpirableItem('employer-popup')) {
        return;
    }

    setExpirableItem('employer-popup', 'expires', EMPLOYER_EXPIRY);

    window.dataLayer = window.dataLayer || [];

    container.style.display = 'block';
    window.dataLayer.push({ event: 'b2b_popup_show' });

    if (container.querySelector('.js-popup--btn')) {
        container.querySelector('.js-popup--btn').addEventListener('click', (e) => {
            window.dataLayer.push({ event: 'b2b_popup_navigate', label: 'Recommend page' });
        });
    }

    if (container.querySelector('.js-popup--close')) {
        container.querySelector('.js-popup--close').addEventListener('click', (e) => {
            e.preventDefault();
            container.style.display = 'none';
        });
    }
};

const showEmployeePopup = (e) => {
    const container = document.getElementById('employee-popup');

    if (!container || getExpirableItem('employee-popup')) {
        return;
    }

    if (e.clientY < 50 && e.relatedTarget == null && e.target.nodeName.toLowerCase() !== 'select') {
        document.removeEventListener('mouseout', showEmployeePopup);

        setExpirableItem('employee-popup', 'expires', EMPLOYEE_EXPIRY);

        window.dataLayer = window.dataLayer || [];

        container.style.display = 'block';
        window.dataLayer.push({ event: 'b2c_popup_show' });

        if (container.querySelector('.js-popup--btn')) {
            container.querySelector('.js-popup--btn').addEventListener('click', (e) => {
                window.dataLayer.push({ event: 'b2c_popup_navigate', label: 'Recommend page' });
            });
        }

        if (container.querySelector('.js-popup--close')) {
            container.querySelector('.js-popup--close').addEventListener('click', (e) => {
                e.preventDefault();
                container.style.display = 'none';
            });
        }
    }
};

const inititatePopup = () => {
    if (document.getElementById('employee-popup') && !getExpirableItem('employee-popup')) {
        setTimeout(() => {
            document.addEventListener('mouseout', showEmployeePopup);
        }, EMPLOYEE_DELAY);
    }

    if (document.getElementById('employer-popup') && !getExpirableItem('employer-popup')) {
        setTimeout(showEmployerPopup, EMPLOYER_DELAY);
    }
};

export default inititatePopup;
